import { createRouter, createWebHistory } from "vue-router";
if (localStorage.getItem("lang") == null) localStorage.setItem("lang", "hk");
const routes = [
	{ path: "/", name: "main", component: () => import("@/view/MainPage.vue") },
	{
		name: "login",
		path: "/login",
		component: () => import("@/view/LoginPage.vue"),
	},
	{
		name: "forgotpw",
		path: "/forgotpw",
		component: () => import("@/view/ForgotPWPage.vue"),
	},
	{
		name: "forgotpwSuccss",
		path: "/forgotpwsuccess",
		component: () => import("@/view/ForgotPWPage.vue"),
	},
];
const router = createRouter({
	history: createWebHistory(),
	routes: routes,
});
export default router;
